import {
    Input,
    OnInit,
    Component,
    ViewChild,
    OnDestroy,
    ElementRef,
    HostListener,
} from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { NgClass, NgStyle, NgIf, AsyncPipe } from '@angular/common';

import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuthenticationFacade } from '@qwyk/hub/authentication';

import { HelpModalComponent } from '../help-modal/help-modal.component';
import { MenuSideBarService } from '../../services/menu-side-bar.service';

@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss'],
    standalone: true,
    imports: [NgClass, NgStyle, RouterLinkActive, RouterLink, NgIf, FontAwesomeModule, TooltipModule, AsyncPipe, TranslatePipe, FontAwesomeModule]
})
export class SideBarComponent implements OnInit, OnDestroy {
    public user$ = this.authentication.user$;

    @ViewChild('wrapper', { static: true }) wrapper: ElementRef;
    @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef;
    @ViewChild('scrollContainerContent', { static: true })
    scrollContainerContent: ElementRef;
    @ViewChild('staticContainer', { static: true }) staticContainer: ElementRef;
    public shouldScrollContainerScroll = false;
    public ref: DynamicDialogRef | undefined;

    @Input() public isMagayaNetwork = false;

    constructor(
        private dialogService: DialogService,
        public menuSideBar: MenuSideBarService,
        private authentication: AuthenticationFacade,
    ) {}

    ngOnInit(): void {
        this.scrollContainerContentEl.onresize = () => this.onWindowResize();
        setTimeout(() => {
            this.onWindowResize();
        }, 50);
    }

    public get scrollContainerContentEl(): HTMLElement {
        return this.scrollContainerContent.nativeElement;
    }

    private get staticContainerEl(): HTMLElement {
        return this.staticContainer.nativeElement;
    }

    private get wrapperEl(): HTMLElement {
        return this.wrapper.nativeElement;
    }

    @HostListener('window:resize')
    public onWindowResize() {
        this.shouldScrollContainerScroll = this.scrollContainerContentEl.clientHeight >
            this.wrapperEl.clientHeight - this.staticContainerEl.clientHeight;
    }

    public onShowHelpCenter() {
        this.ref = this.dialogService.open(HelpModalComponent, {
            showHeader: false,
            closable: true,
            width: '75%',
            position: 'center',
            contentStyle: {
                'padding': 0
            }
        });
    }

    ngOnDestroy() {
        if (this.ref) {
            this.ref.close();
        }
    }
}
